import { Injectable, inject } from '@angular/core';
import {of, ReplaySubject} from 'rxjs';
import { SsApiService } from '../api/ss-api.service';
import {StaticContentService} from '../static-content.service';
import { catchError, distinctUntilChanged, filter, first, shareReplay, skip, tap } from 'rxjs/operators';
import {DEFAULT_TRANSLATES, ILootboxesTranslatesCMS} from './lootbox-translates';
import {TimeService} from '../time.service';

const LOOTBOXES_TRANSLATES_SLUG = 'lootboxes-translates';

@Injectable({
  providedIn: 'root'
})
export class LootboxService {
  private _ssApi = inject(SsApiService);
  private _static = inject(StaticContentService);
  private _time = inject(TimeService);


  /**
   * Current first lootbox from list
   */
  public currentLootbox: any;

  /**
   * Current chosen lootbox prize
   */
  public currentLootboxPrize: any;

  /**
   * Loot box isuued list for promo
   * @private
   */
  private _promoLootBoxList$: ReplaySubject<any> = new ReplaySubject<any>(1);

  /**
   * Set true if lootboxes translates loaded from CMS
   * @private
   */
  private _lootboxesTranslatesLoaded = false;

  /**
   * Lootboxes translates Replay Subject
   * @private
   */
  public lootboxesTranslates$ = this._static.item({slug: LOOTBOXES_TRANSLATES_SLUG}).pipe(
    filter(data => Boolean(data) && !this._lootboxesTranslatesLoaded),
    tap(data => this._lootboxesTranslatesData = data[0]),
    catchError(() => {
      this._lootboxesTranslatesLoaded = true;
      this._lootboxesTranslatesData = {
        FieldModifyTranslations: null,
        Translates: {}
      };
      return of({});
    }),
    shareReplay(1)
  );

  /**
   * Save lootboxes translates data for use in future
   * @private
   */
  private _lootboxesTranslatesData: ILootboxesTranslatesCMS;

  /**
   * Activate loot box by id
   * @param id
   */
  public activateLootBox(id) {
    return this._ssApi.playerLootboxActivate(id);
  }

  /**
   * Cancel lootbox
   * @param id
   */
  public cancelLootbox(id) {
    return this._ssApi.playerLootboxCancel(id);
  }


  /**
   * Resolve lootbox translates for use in template
   * Find lootbox by field (FieldModifyTranslations) from CMS and add translates
   * @param lootbox
   * @private
   */
  public resolveLootboxTranslates(lootbox: any) {
    const translatesArr = Object.entries(this._lootboxesTranslatesData && this._lootboxesTranslatesData.Translates || {});

    if (translatesArr.length && this._lootboxesTranslatesData.FieldModifyTranslations) {
      const field = this._lootboxesTranslatesData.FieldModifyTranslations.trim();

      const translates = translatesArr.find(tr => {
        if (tr[0].includes(',')) {
          return tr[0]
            .trim()
            .toLocaleLowerCase()
            .split(',')
            .map(t => t.trim())
            .some(t => String(lootbox[field]).trim().toLocaleLowerCase() === t.trim().toLocaleLowerCase());
        }

        return String(lootbox[field]).trim().toLocaleLowerCase() === tr[0].trim().toLocaleLowerCase();
      });

      if (translates) {
        lootbox = {...lootbox, ...translates[1]};
      } else {
        lootbox = {...lootbox, ...DEFAULT_TRANSLATES};
      }
    } else {
      lootbox = {...lootbox, ...DEFAULT_TRANSLATES};
    }

    return lootbox;
  }
}
